<template>
  <Teleport to="body">
    <div
      v-show="props.isShow"
      ref="tooltipWrapper"
      :class="['common-tooltip', props.class]"
      :style="tooltipPosition"
    >
      <template v-if="props.text">
        {{ props.text }}
      </template>
      <template v-else>
        <slot />
      </template>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useTooltipPosition } from './uses';

interface Props {
  isShow: boolean;
  evt?: MouseEvent | null;
  position?: {
    top: number;
    left: number;
    /** 앵커(행/바) 높이 — 지정 시 top(앵커 상단) 아래로 툴팁을 배치하고, 하단 공간 부족 시 앵커 상단 위로 flip. */
    height?: number;
  };
  class?: string;
  text?: string;
}
const props = defineProps<Props>();

const { tooltipWrapper, tooltipPosition } = useTooltipPosition(props);
</script>

<style lang="scss">
.common-tooltip {
  position: absolute;
  z-index: 850;
  box-shadow: var(--chart-tooltip-box-shadow);
  white-space: pre-line;

  @include set-scrollbar();

  &:not(.custom) {
    padding: 14px 12px;
    border: 1px solid var(--common-tooltip-simple-text-bg-color);
    border-radius: 2px;
    background-color: var(--common-tooltip-simple-text-bg-color);
    color: var(--common-tooltip-simple-text-font-color);
  }
}
</style>
